import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import AssetAttributeService from "services/Setup/Organization/assetAttributeService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  AssetAttributeList: {},
  refreshList: false,
  AssetAttributeApprovalList: {},
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
};

export const postAssetAttribute = createAsyncThunk(
  "assetAttribute/postAssetAttribute",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetAttributeService.postAssetAttribute(data);
  
      if (response.status === 200) {
        if (response.data.status == "Success") {
          
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
         
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
 
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error:", error);
      // message.error({
      //   status: error,
      //   content: error,
      // });
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAssetAttributeList = createAsyncThunk(
  "assetAttribute/getAssetAttributeList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await AssetAttributeService.getAssetAttributeList(
        userInput
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAssetAttributeApprovalList = createAsyncThunk(
  "assetAttribute/getAssetAttributeApprovalList",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await AssetAttributeService.getAssetAttributeApprovalList(userInput);
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAssetAttributeApproval = createAsyncThunk(
  "assetAttribute/putAssetAttributeApproval",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetAttributeService.putAssetAttributeApproval(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAssetAttributeRequest = createAsyncThunk(
  "assetAttribute/putAssetAttributeRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetAttributeService.putAssetAttributeRequest(
        data
      );
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          // message: "Error",
          // description: "Unexpected response!",
          message: response.status,
          description: response.statusText,
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getAssetAttributeDetail = createAsyncThunk(
  "assetAttribute/getAssetAttributeDetail",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetAttributeService.getAssetAttributeDetail(
        data
      );
      if (response.status === 200) {
        if (response && response.data) {
          return response;
        }
      } else {
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const updateAssetAttribute = createAsyncThunk(
  "assetAttribute/updateAssetAttribute",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetAttributeService.updateAssetAttribute(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteAssetAttribute = createAsyncThunk(
  "assetAttribute/deleteAssetAttribute",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AssetAttributeService.deleteAssetAttribute(data);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const AssetAttributeSlice = createSlice({
  name: "assetAttribute",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder

      //post
      .addCase(postAssetAttribute.pending, (state) => {
        state.loading = true;
      })
      .addCase(postAssetAttribute.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload.data.message;
        state.refreshList = true;
      })
      .addCase(postAssetAttribute.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list
      .addCase(getAssetAttributeList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetAttributeList.fulfilled, (state, action) => {
        state.loading = false;
        state.AssetAttributeList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getAssetAttributeList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //AssetAttribute approval list
      .addCase(getAssetAttributeApprovalList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getAssetAttributeApprovalList.fulfilled, (state, action) => {
        state.loading = false;
        state.AssetAttributeApprovalList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getAssetAttributeApprovalList.rejected, (state, action) => {
        state.loading = false;
        state.AssetAttributeApprovalList = action.payload;
      })

      //AssetAttribute approval approve
      .addCase(putAssetAttributeApproval.pending, (state) => {
        state.loading = true;
        // state.redirect = "";
      })
      .addCase(putAssetAttributeApproval.fulfilled, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(putAssetAttributeApproval.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //AssetAttribute approval request
      .addCase(putAssetAttributeRequest.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(putAssetAttributeRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(putAssetAttributeRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //detail
      .addCase(getAssetAttributeDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAssetAttributeDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getAssetAttributeDetail.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //update
      .addCase(updateAssetAttribute.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAssetAttribute.fulfilled, (state, action) => {
        state.loading = false;
        // state.redirect = "/";
        // state.result = action.payload;
        // state.showMessage = true;
      })
      .addCase(updateAssetAttribute.rejected, (state, action) => {
        state.loading = false;
        // state.result = action.payload;
        // state.showMessage = true;
      })

      //delete
      .addCase(deleteAssetAttribute.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAssetAttribute.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(deleteAssetAttribute.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
} = AssetAttributeSlice.actions;

export default AssetAttributeSlice.reducer;
